import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {Button, GridList} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import AddIcon from '@material-ui/icons/Add';
import constants from "../../constants";
import {ColorActivityFormImage, ColorOrange} from "src/styles/Colors";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import {getInitialFiles} from "../../utils/ValueHelper";
import {cloneDeep} from "lodash";
import {IMAGE_MAX_SIZE, IMAGE_MAX_WIDTH_HEIGHT} from "../commons/FilePicker";
import FileHelper from "../../utils/FileHelper";
import SingleFilePicker, {ACCEPTED_IMAGE_MIMES, FILE_TYPE_IMAGE} from "../commons/SingleFilePicker";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import {ImageIcon} from "src/js/components/commons/ViewHelper";
import AutoCompleteView from "src/js/components/commons/AutoCompleteView";
import {fetchActivityQuestionsDropDown} from "src/js/actions/activitiesActions";
import Space from "src/js/components/commons/Space";
import {logDebug} from "src/js/utils/AppLog";

const useStyles = () => ({
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    minWidth: 260,
    width: '100%',
    margin: 1,
    marginBottom: 16 + 1,
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageCustomiseQuestion: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    // border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    marginBottom: 16,
    padding: 4,
  },
});

class ManageActivityInternalQuestion extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.maxOptionsCount = 4;
    this.maxGamePlayAudioDuration = 10*1000;
    this.maxBgAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxGamePlayAudioDuration = activityData.mediaConfigs.maxGamePlayAudioDuration;
      this.maxBgAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }

    let inQuestionState = activityData.inQuestionState;
    let inQuestionSubState = activityData.inQuestionSubState;
    if (inQuestionState === undefined) {
      if (activityData.inQuestion) {
        inQuestionState = constants.activity.state.ACTIVE;
        inQuestionSubState = constants.activity.state.ACTIVE;
      } else {
        inQuestionState = 0;
        inQuestionSubState = 0;
      }
    }
    this.state = this.getStateForQuestion(activityData.inQuestion, inQuestionState, inQuestionSubState, activityData.inQuestionSelected);
  }

  getStateForQuestion(inQuestion = null, inQuestionState = 0, inQuestionSubState = 0, inQuestionSelected = null) {
    const {activityData} = this.props;

    let imageUrl = null;
    let imageFiles = null;
    this.qOptions = null;
    this.initialFiles2 = null;
    if (inQuestionState === constants.activity.state.ACTIVE) {
      this.qOptions = [];
      let optionNo = 1;
      const questionOptions = inQuestion ? inQuestion.qOptions || inQuestion.subOptions : null;
      if (questionOptions) {
        questionOptions.forEach((optionL) => {
          const option = {
            optionNo: optionNo,
            id: optionL.id,
            name: optionL.name,
            nameAr: optionL.nameAr || ''
          };
          this.qOptions.push(option);

          optionNo++;
        });
      }
      if (this.qOptions.length < this.maxOptionsCount) {
        for (let i = this.qOptions.length; i < this.maxOptionsCount; i++) {
          this.qOptions.push({
            id: -i,
            optionNo: optionNo,
            name: '',
            nameAr: '',
          });
          optionNo++;
        }
      }
      imageUrl = inQuestion ? inQuestion.imageUrl2 : null;
      imageFiles = inQuestion ? inQuestion.imageFiles2 : null;
      this.initialFiles2 = getInitialFiles(imageFiles, imageUrl, FILE_TYPE_IMAGE);
    }

    logDebug('iQ:questionState', inQuestionState);
    logDebug('iQ:inQuestionSubState', inQuestionSubState);
    const newState = {
      inQuestionState: inQuestionState,
      inQuestionSubState: inQuestionSubState,
      inQuestionSelected: inQuestionSelected,
      id: inQuestion ? inQuestion.id || 0 : 0,
      qTitle: inQuestion ? inQuestion.qTitle || '' : '',
      imageUrl2: imageUrl,
      imageFiles2: imageFiles,
      isImage2Deleted: inQuestion ? inQuestion.isImage2Deleted : null,
      showValidationMsg: false,
      reload: false
    };

    if (!this.state || this.state.inQuestionState !== newState.inQuestionState
      || this.state.inQuestionSubState !== newState.inQuestionSubState) {
      this.stateOptions = [{'id': 0, 'subId': 0, 'name': <FormattedMessage id='activity.noQuestion'/>}];
      // if (inQuestionState === constants.activity.state.ACTIVE && inQuestion && inQuestion.id > 0 && !newState.inQuestionSelected) {
      if (inQuestionState === constants.activity.state.ACTIVE && inQuestionSubState === constants.activity.state.ACTIVE) {
        this.stateOptions.push({'id': 1, 'subId': 1, 'name': <FormattedMessage id='activity.optionQuestion'/>});
      } else {
        // this.stateOptions.push({'id': 1, 'subId': 2, 'name': <FormattedMessage id='activity.addNewQuestion'/>});
        this.stateOptions.push({'id': 1, 'subId': 2, 'name': <FormattedMessage id='activity.optionQuestion'/>});
        // this.stateOptions.push({'id': 1, 'subId': 3, 'name': <FormattedMessage id='activity.selectQuestion'/>});
      }
    }

    return newState;
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    this.props.fetchActivityQuestionsDropDown();
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    const {
      inQuestionState,
      inQuestionSubState,
      inQuestionSelected,
      id,
      qTitle,
      imageUrl2,
      imageFiles2,
      isImage2Deleted,
    } = this.state;

    if (inQuestionState === constants.activity.state.ACTIVE) {
      if (!excludeError) {
        if (this.isQuestionTitleIncorrect(qTitle)
          || (!this.qOptions || this.qOptions.length === 0)
          || !this.areQuestionOptionsCorrect()
        ) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      }

      const qOptions = [];
      this.qOptions.forEach((qOption) => {
        if (qOption.name && qOption.name.trim().length > 0) {
          const qOptionL = cloneDeep(qOption);
          qOptions.push(qOptionL);
        }
      });
      return {
        inQuestionState,
        inQuestionSubState,
        inQuestionSelected,
        inQuestion: {
          id: id,
          type: constants.activity.types.QUESTION,
          qTitle,
          qOptions: qOptions,
          imageUrl2,
          imageFiles2,
          isImage2Deleted,
        }
      };
    }
    return {
      inQuestionState,
      inQuestionSubState,
      inQuestionSelected: null,
      inQuestion: null,
    }
  }

  render() {
    const {activityData, activities, classes, isXS} = this.props;
    const {
      inQuestionState,
      inQuestionSubState,
      qTitle,
      showValidationMsg
    } = this.state;

    const showQuestion = inQuestionState === constants.activity.state.ACTIVE && (inQuestionSubState !== 3 || qTitle);

    return (
      <div className={classes.formActivityWide}>

        <SectionHeaderView
          labelId={'activity.askInternalQuestion'}
          // subLabelId={this.props.isEditing ? 'activity.askInternalQuestionHintEdit' : 'activity.askInternalQuestionHint'}
          subLabelColor={ColorOrange} />
        <div className={classes.viewRowFullWidth}>
          {this.stateOptions.map((item, index) => {
            return this.getOptionsRadioView(item, index);
          })}
        </div>
        <FieldSpace multiplier={2} />

        {inQuestionState === constants.activity.state.ACTIVE && inQuestionSubState === 3 ?
          <React.Fragment>
            <Space top={isXS ? -FIELD_SPACE_XS : -FIELD_SPACE} />
            <AutoCompleteView
              ref={(ref) => this.refAutoCompleteView = ref}
              fullWidth
              variant="outlined"
              multiple={false}
              label={this.context.intl.formatMessage({id: 'activity.selectExistingQuestion'})}
              // placeholder={this.context.intl.formatMessage({id: 'activity.manage.searchNSelectReward'})}
              options={activities.questionsNOptions}
              selectedValues={this.state.inQuestionSelected}
              inputValue={this.state.inQuestionSelected ? this.state.inQuestionSelected.title : ''}
              onInputChange={this.onChangeActivityRewarded}
              onSelect={this.onSelectQuestion}
            />
            {showValidationMsg && !qTitle ? <FormHelperText className={classes.helperErrorPadding}><FormattedMessage id={'activity.selectQuestionToProceed'}/></FormHelperText> : null}
            <FieldSpace multiplier={2} />
          </React.Fragment>
          : null
        }

        {showQuestion ?
          <React.Fragment>
            {/*<SectionHeaderView labelId={'activity.questionNOptions'} extraBottomSpace={true}/>*/}
            <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
              {/*{this.getImageView()}*/}
              {/*<FieldSpace vertical={true} />*/}

              <React.Fragment>
                <TextField
                  variant="filled"
                  required={true}
                  fullWidth
                  multiline
                  rows={isXS ? 1 : 2}
                  rowsMax={8}
                  size="small"
                  type="text"
                  id="qTitle"
                  name="qTitle"
                  label={<FormattedMessage id={activityData.type === constants.activity.types.GUESS ? 'activity.guessTitle' : 'activity.questionTitle'} />}
                  InputProps={{disableUnderline: true}}
                  inputProps={{maxLength: 200}}
                  value={qTitle}
                  onChange={this.onChange}
                  error={showValidationMsg && this.isQuestionTitleIncorrect(qTitle)}
                  helperText={showValidationMsg && this.isQuestionTitleIncorrect(qTitle) && <FormattedMessage id='generic.validation.required' />}
                />
              </React.Fragment>
            </div>
            <FieldSpace multiplier={1.5}/>

            <SectionHeaderView labelId={'activity.options'} subLabelId={'activity.hintQuestionOptions'} />
            <div style={{margin: isXS ? -6 : -8}}>
              <GridList spacing={0} cols={isXS ? 2 : 2} className={classes.optionsWrapper} cellHeight={'auto'}>
                {this.qOptions.map((option, optionIndex) => this.getQuestionOptionView(optionIndex, option.name, option.nameAr))}
              </GridList>
              {/*<FormHelperText className={classes.helper} style={{marginTop: -2, marginBottom: 2}}><FormattedMessage id='activity.hintQuestionOptions' /></FormHelperText>*/}
            </div>
            <FieldSpace />

          </React.Fragment>
          : null
        }
      </div>
    )
  }

  getOptionsRadioView(option, index) {
    const {classes, app} = this.props;

    const onClick = () => {
      this.updateState(this.getStateForQuestion(null, option.id, option.subId));
    };
    const isSelected = option.id === this.state.inQuestionState && option.subId === this.state.inQuestionSubState;
    const margin = index > 0 ? 12 : 0;
    return (
      <Button
        fullWidth={true}
        key={option.id +'-'+ option.subId}
        color={isSelected ? 'primary' : 'secondary'}
        size={this.props.isXS ? 'medium' : 'large'}
        variant={"outlined"}
        onClick={onClick}
        style={{marginRight: !app.isLTR ? margin : 0, marginLeft: app.isLTR ? margin : 0}}
        className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
        startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
        <FormattedMessage id={option.name} />
      </Button>
    );
  }

  onSelectQuestion = (value) => {
    logDebug('iQ:onSelectQuestion', value);
    const newState = this.getStateForQuestion(value, this.state.inQuestionState, this.state.inQuestionSubState, value);
    this.updateState(newState);
  };

  getImageView() {
    const {isXS} = this.props;
    return (
      <React.Fragment>
        {!isXS ? <MediaPlaceholder labelId={'activity.manage.questionImage'} /> : null}
        <SingleFilePicker
          key={this.initialFiles2 && this.initialFiles2.length > 0 ? this.initialFiles2[0].url : ''}
          required={false}
          hideDropzoneText={true}
          size={isXS ? 'xsmall' : 'small'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_IMAGE_MIMES}
          maxFileSize={IMAGE_MAX_SIZE}
          maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
          aspectRatio={16/9}
          initialFiles={this.initialFiles2}
          onChange={(files) => {
            this.onChangeFiles(files, 'imageUrl2');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'imageUrl2');
          }}
        />
        <FieldSpace />
      </React.Fragment>
    );
  }

  isQuestionTitleIncorrect(qTitle) {
    return !qTitle || qTitle.trim().length === 0;
  }

  getQuestionOptionsView() {
    const {qTitle, showValidationMsg} = this.state;
    const {activityData, classes} = this.props;
    let views = [];
    let count = 1;
    this.qOptions.forEach((item) => {
      views.push(this.getQuestionOptionView(count, item.name, item.nameAr));
      count++;
    });
    const questionOptionMaxLimit = 8;
    const isQuestionOptionLimitReached = this.qOptions.length === questionOptionMaxLimit;
    const canAddNewQuestionOption = !isQuestionOptionLimitReached && (activityData.type === constants.activity.types.GUESS || qTitle) && this.areQuestionOptionsCorrect();
    return (
      <div className={classes.viewColumnFullWidth}>
        {views}
        <div className={classes.viewRowFullWidth}>
          <FormControl
            required
            size="small"
            error={showValidationMsg && (!this.qOptions || this.qOptions.length === 0)}>
            <Button
              variant={"outlined"}
              color="primary"
              disabled={!canAddNewQuestionOption}
              startIcon={<AddIcon />}
              onClick={this.onAddNewQuestionOptionClicked}>
              {<FormattedMessage id={count === 1 ? 'activity.manage.addQuestionOption' : 'activity.manage.addAnotherOption'} />}
            </Button>
            {showValidationMsg && (!this.qOptions || this.qOptions.length === 0) && <FormHelperText className={classes.helperError}><FormattedMessage id='activity.validation.optionRequired' /></FormHelperText>}
          </FormControl>
        </div>
      </div>
    );
  }

  getQuestionOptionView(optionIndex, optionEn, optionAr) {
    const {showValidationMsg} = this.state;
    const {classes, isXS} = this.props;
    const optionNumber = optionIndex + 1;
    const isOptionIncorrect = showValidationMsg && optionIndex === 0 && (!optionEn || optionEn.trim().length === 0);
    let disabled = false;
    let prevOption = null;
    if (optionIndex > 0) {
      prevOption = this.qOptions[optionIndex - 1];
      disabled = !prevOption.name || prevOption.name.trim().length === 0;
    }
    return (
      <div key={'O'+ optionNumber} className={classes.viewColumn} style={{padding: isXS ? 6 : 8}}>
        {/*<IconButton*/}
        {/*  size={'small'}*/}
        {/*  className={classes.buttonRemoveSmall}*/}
        {/*  onClick={() => {*/}
        {/*    this.qOptions.splice(optionNumber - 1, 1);*/}
        {/*    this.reloadView();*/}
        {/*  }}>*/}
        {/*  <CloseIcon fontSize={'inherit'} style={{color: ColorWhite}} />*/}
        {/*</IconButton>*/}
        {/*<Space vertical={8} />*/}
        <div className={classes.flexRowNoCenter}>
          <div className={classes.flex1}>
            <TextField
              disabled={disabled}
              variant="filled"
              required={optionIndex === 0}
              fullWidth
              size="small"
              type="text"
              id="optionEn"
              name="optionEn"
              label={<FormattedMessage id={'activity.manage.questionOption'} values={{value: optionNumber}} />}
              InputProps={{disableUnderline: true}}
              inputProps={{maxLength: 40}}
              value={optionEn}
              onChange={(event) => {
                const value = event.target.value;
                this.qOptions[optionIndex].name = value;
                this.updateState({showValidationMsg: false});
              }}
              error={isOptionIncorrect}
              helperText={isOptionIncorrect && <FormattedMessage id='activity.validationOptionRequired' />}
            />
          </div>
        </div>
      </div>
    );
  }

  areQuestionOptionsCorrect() {
    let isCorrect = true;
    const firstOption = this.qOptions[0];
    if (!firstOption.name || firstOption.name.trim().length === 0) {
      isCorrect = false;
    } else if (!firstOption.name || firstOption.name.trim().length === 0) {
      isCorrect = false;
    }
    return isCorrect;
  }

  onAddNewQuestionOptionClicked = () => {
    this.qOptions.push({
      name: '',
      nameAr: ''
    });
    this.reloadView();
  };

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eFileUrl = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eFileUrl)) {
          lFileUrl = eFileUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      imageUrl2,
      imageFiles2,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eFileUrl = null;
    let eFiles = null;
    let eFileObjs = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    let keyIsFileDeleted = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      eFiles = imageFiles1;
      eFileObjs = fileObjsImage1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
      keyIsFileDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      eFiles = imageFiles2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyIsFileDeleted = 'isImage2Deleted';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      eFiles = bgAudioFiles;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
      keyIsFileDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eFileUrl;
    if (eFiles) {
      let index = 0;
      eFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eFileUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles, [keyIsFileDeleted]: true});
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityInternalQuestion.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityInternalQuestion.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActivityQuestionsDropDown: (search) => dispatch(fetchActivityQuestionsDropDown(search, 1, 1000, true)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityInternalQuestion))
);
